var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "identify",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.205,
    height: 98,
    viewBox: "0 0 101.205 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.217,
    y1: 0.724,
    x2: 0.924,
    y2: -0.007,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd8d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#ffb2b2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M26.9,26.659c10.005.25,9.766-15.991,15.883-18.385,15.02-2.8,60.314,30.588,58.359,52.186-.8,6.863-12.18,4.182-17.01,3.773C72.563,62.2,62.542,66.151,60.09,78.327c-1.822,10.115-5.62,20.828-15.731,25.282-8.506,4.1-19.95,3.322-26.806-3.538-9.474-10.336-3.651-25.559,2.516-36.2,1.368-2.541,2.792-5.49,1.773-8.191a5.711,5.711,0,0,0-7.091-3.05c-1.075.388-6.733,4.478-10.61,2.293-7.9-4.454-6.592-29,22.762-28.265Z",
    transform: "translate(0 -8.109)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    transform: "translate(6.954 2.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(10.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026",
    transform: "translate(0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M149.36,81.867H100.588a3.95,3.95,0,0,0-3.949,3.951v53.946H88.275A1.975,1.975,0,0,0,86.3,141.74v18a1.975,1.975,0,0,0,1.974,1.976H149.36a3.95,3.95,0,0,0,3.949-3.951V85.818A3.95,3.95,0,0,0,149.36,81.867Z",
    transform: "translate(-86.301 -69.568)",
    fill: "#0000cb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "translate(10.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M191.574,137.72H142.629a3.957,3.957,0,0,1-3.963-3.951V61.818a3.957,3.957,0,0,1,3.963-3.951h48.945a3.957,3.957,0,0,1,3.963,3.951v71.951A3.957,3.957,0,0,1,191.574,137.72Z",
    transform: "translate(-138.666 -50.324)",
    fill: "#fa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M211,85.077v65.9a1.979,1.979,0,0,1-1.981,1.975H166.253a1.979,1.979,0,0,1-1.981-1.975v-65.9a1.979,1.979,0,0,1,1.981-1.975h42.761A1.979,1.979,0,0,1,211,85.077Z",
    transform: "translate(-159.199 -70.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M164.272,338.93v17.414a1.982,1.982,0,0,0,1.981,1.981h42.761A1.982,1.982,0,0,0,211,356.344V338.93Z",
    transform: "translate(-159.199 -275.93)",
    fill: "#d8d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M236.672,83.1V87.36a1.981,1.981,0,0,1-1.981,1.981H208.783A1.981,1.981,0,0,1,206.8,87.36V83.1Z",
    transform: "translate(-193.302 -70.559)",
    fill: "#d8d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M227.192,25.2a5.456,5.456,0,0,0-10.912,0h-7.5a1.981,1.981,0,0,0-1.981,1.981V31.84a1.981,1.981,0,0,0,1.981,1.981H234.69a1.981,1.981,0,0,0,1.981-1.981V27.185A1.981,1.981,0,0,0,234.69,25.2Z",
    transform: "translate(-193.301 -19.794)",
    fill: "#b2b2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M245.123,76.613V74.15a.991.991,0,0,0-.991-.991H221.791a.991.991,0,0,0-.991.991v2.463Z",
    transform: "translate(-204.527 -62.586)",
    fill: "#9393ff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 1.783,
    cy: 1.783,
    rx: 1.783,
    ry: 1.783,
    transform: "translate(36.889 3.416)",
    fill: "#6c6cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006",
    transform: "translate(23.374 19.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002",
    transform: "translate(8.548 9.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M260.668,167.711H249.18a.991.991,0,0,1,0-1.981h11.489a.991.991,0,1,1,0,1.981Z",
    transform: "translate(-248.189 -165.73)",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005",
    transform: "translate(3.023 23.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M231.656,254.357a20.408,20.408,0,0,1-7.871-1.316c-2.876-1.259-3.48-3.141-3.48-4.5a5.389,5.389,0,0,1,2-4.114,15.252,15.252,0,0,1,6.756-2.982,23.086,23.086,0,0,1,7-.436.991.991,0,0,1-.233,1.967c-3.211-.38-9.4.445-12.2,2.932a3.449,3.449,0,0,0-1.331,2.633c0,.415,0,1.679,2.293,2.683,2.42,1.059,6.48,1.4,10.861.917,4.112-.455,7.656-1.569,9.029-2.836a4.029,4.029,0,0,0,1.2-4.491c-.82-2.341-4-5.233-10.274-5.681a.991.991,0,1,1,.141-1.976c5.949.425,10.66,3.173,12,7a5.984,5.984,0,0,1-1.725,6.6C243.535,252.866,237.362,254.357,231.656,254.357Z",
    transform: "translate(-220.305 -237.155)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004",
    transform: "translate(8.252 8.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M272.054,282.744h-9.111a.991.991,0,1,1,0-1.981h9.111a.991.991,0,1,1,0,1.981Z",
    transform: "translate(-261.952 -280.763)",
    fill: "#b2b2ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M235.215,124.923c-1.482-4.229-6.7-7.265-13.293-7.737a.991.991,0,0,0-.141,1.976c7.052.5,10.637,3.771,11.564,6.416a4.606,4.606,0,0,1-1.369,5.134c-1.549,1.431-5.529,2.685-10.141,3.2-4.909.543-9.462.158-12.179-1.032-.65-.285-2.628-1.15-2.628-3.1a4.576,4.576,0,0,1,1.782-3.4c3.069-2.727,9.632-4.257,13.45-3.8a.991.991,0,1,0,.233-1.967c-4.332-.514-11.394,1.088-15,4.291a6.46,6.46,0,0,0-2.448,4.885c0,1.48.662,3.534,3.815,4.914a22.9,22.9,0,0,0,8.762,1.436c.238,0,.481-.006.723-.01l.2,5.322a.991.991,0,0,0,.989.953h.038a.991.991,0,0,0,.953-1.027l-.2-5.335c.571-.039,1.147-.087,1.728-.151,5.159-.571,9.371-1.958,11.267-3.709a6.567,6.567,0,0,0,1.9-7.245Z",
    transform: "translate(-205.047 -117.184)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007",
    transform: "translate(19.71 20.235)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 0.991,
    cy: 0.991,
    rx: 0.991,
    ry: 0.991,
    transform: "translate(6.189)",
    fill: "#fa6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 0.991,
    cy: 0.991,
    rx: 0.991,
    ry: 0.991,
    transform: "translate(3.094)",
    fill: "#fa6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 0.991,
    cy: 0.991,
    rx: 0.991,
    ry: 0.991,
    fill: "#fa6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(21.141 66.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "translate(0 8.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M201.607,402.568H194.79a.991.991,0,0,0,0,1.981h6.817a.991.991,0,0,0,0-1.981Z",
    transform: "translate(-193.799 -402.568)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    transform: "translate(0 4.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M201.607,382.186H194.79a.991.991,0,1,0,0,1.981h6.817a.991.991,0,1,0,0-1.981Z",
    transform: "translate(-193.799 -382.186)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M197.644,357.8H194.79a.991.991,0,1,0,0,1.981h2.855a.991.991,0,0,0,0-1.981Z",
    transform: "translate(-193.799 -357.804)",
    fill: "#fa6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    transform: "translate(13.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(0 8.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M267.786,402.568h-6.817a.991.991,0,0,0,0,1.981h6.817a.991.991,0,0,0,0-1.981Z",
    transform: "translate(-259.978 -402.568)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    transform: "translate(0 4.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M267.786,382.186h-6.817a.991.991,0,0,0,0,1.981h6.817a.991.991,0,0,0,0-1.981Z",
    transform: "translate(-259.978 -382.186)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M263.823,357.8h-2.855a.991.991,0,0,0,0,1.981h2.855a.991.991,0,0,0,0-1.981Z",
    transform: "translate(-259.978 -357.804)",
    fill: "#fa6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(26.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018",
    transform: "translate(0 8.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M333.966,402.568h-6.817a.991.991,0,0,0,0,1.981h6.817a.991.991,0,1,0,0-1.981Z",
    transform: "translate(-326.158 -402.568)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(0 4.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M333.966,382.186h-6.817a.991.991,0,1,0,0,1.981h6.817a.991.991,0,1,0,0-1.981Z",
    transform: "translate(-326.158 -382.186)",
    fill: "#8282ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M330,357.8h-2.855a.991.991,0,1,0,0,1.981H330a.991.991,0,1,0,0-1.981Z",
    transform: "translate(-326.158 -357.804)",
    fill: "#ff6c6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    transform: "translate(18.796 39.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 7.46,
    cy: 7.46,
    rx: 7.46,
    ry: 7.46,
    fill: "#fa6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114",
    transform: "translate(25.446 51.573) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(2.615 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M4.276,1.981H.991A.991.991,0,0,1,.991,0H4.276a.991.991,0,1,1,0,1.981Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 0.991,
    cy: 0.991,
    rx: 0.991,
    ry: 0.991,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(0 65.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M88.282,350.927h18.057a1.981,1.981,0,0,1,1.981,1.981v18.057a1.981,1.981,0,0,1-1.981,1.981H88.282a1.981,1.981,0,0,1-1.981-1.981V352.908a1.981,1.981,0,0,1,1.981-1.981Z",
    transform: "translate(-86.301 -350.927)",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113",
    transform: "translate(5.706 7.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M205.683,254.007a1.434,1.434,0,0,1-1.016-.421l-2.81-2.81a1.437,1.437,0,0,1,2.033-2.033l1.794,1.794,4.169-4.169a1.437,1.437,0,1,1,2.033,2.033l-5.185,5.185A1.434,1.434,0,0,1,205.683,254.007Z",
    transform: "translate(-201.435 -245.948)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M77.713,295.574a.987.987,0,0,1-.7-.29l-2.08-2.08a.99.99,0,0,1,0-1.4l2.08-2.08a.99.99,0,0,1,1.4,0l2.08,2.08a.99.99,0,0,1,0,1.4l-2.08,2.08A.988.988,0,0,1,77.713,295.574Zm-.679-3.071.679.679.679-.679-.679-.679Z",
    transform: "translate(-66.808 -236.151)",
    fill: "#ff6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M435.26,27.679a.987.987,0,0,1-.7-.29l-2.08-2.08a.99.99,0,0,1,0-1.4l2.08-2.08a.99.99,0,0,1,1.4,0l2.08,2.08a.99.99,0,0,1,0,1.4l-2.08,2.08A.986.986,0,0,1,435.26,27.679Zm-.679-3.071.679.679.679-.679-.679-.679Z",
    transform: "translate(-353.751 -21.192)",
    fill: "#8282ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M38.171,421.517a.987.987,0,0,1-.7-.29l-2.08-2.08a.99.99,0,0,1,0-1.4l2.08-2.08a.99.99,0,0,1,1.4,0l2.08,2.08a.99.99,0,0,1,0,1.4l-2.08,2.08A.987.987,0,0,1,38.171,421.517Zm-.679-3.071.679.679.679-.679-.679-.679Z",
    transform: "translate(-35.1 -337.228)",
    fill: "#8282ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037",
    transform: "translate(12.379 41.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M448.021,332.893a.991.991,0,0,1-.7-1.691l1.981-1.981a.991.991,0,0,1,1.4,1.4l-1.981,1.981A.987.987,0,0,1,448.021,332.893Z",
    transform: "translate(-378.031 -309.338)",
    fill: "#ff9c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M98.568,234.009a.991.991,0,0,1-.7-1.691l1.981-1.981a.991.991,0,0,1,1.4,1.4l-1.981,1.981a.987.987,0,0,1-.7.29Z",
    transform: "translate(-97.577 -230.046)",
    fill: "#ff9c33"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M145.353,22.318h-4.011a.988.988,0,0,0,0,1.976h4.011a2.966,2.966,0,0,1,2.962,2.964V99.231a2.966,2.966,0,0,1-2.962,2.964H105.046a2.95,2.95,0,0,0,.173-.988V83.2a2.966,2.966,0,0,0-2.962-2.964H93.615V27.259a2.966,2.966,0,0,1,2.962-2.964h8.517v3.5a2.966,2.966,0,0,0,2.962,2.964h25.82a2.966,2.966,0,0,0,2.962-2.964V23.155a2.966,2.966,0,0,0-2.962-2.964h-6.569a6.424,6.424,0,0,0-12.682,0h-6.569a2.966,2.966,0,0,0-2.84,2.128H96.577a4.944,4.944,0,0,0-4.936,4.941V80.233H84.263A2.966,2.966,0,0,0,81.3,83.2v8.98a.987.987,0,1,0,1.975,0V83.2a.989.989,0,0,1,.987-.988h17.994a.989.989,0,0,1,.987.988v18.01a.989.989,0,0,1-.987.988H84.263a.989.989,0,0,1-.987-.988V97.785a.987.987,0,1,0-1.975,0v3.423a2.966,2.966,0,0,0,2.962,2.964h61.091a4.944,4.944,0,0,0,4.936-4.941V27.259a4.944,4.944,0,0,0-4.936-4.941Zm-38.285.837a.989.989,0,0,1,.987-.988h7.473a.988.988,0,0,0,.987-.98,4.45,4.45,0,0,1,8.9,0,.988.988,0,0,0,.987.98h7.473a.989.989,0,0,1,.987.988V27.8a.989.989,0,0,1-.987.988h-25.82a.989.989,0,0,1-.987-.988Z",
    transform: "translate(-65.193 -13.469)",
    fill: "#0000cb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentify);
export default __webpack_public_path__ + "static/media/identify.ed4fd2b6ff2990c49ca992f5fa902267.svg";
export { ForwardRef as ReactComponent };